"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickableImageBlock = exports.ImageMapType = void 0;
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const react_img_mapper_1 = __importDefault(require("react-img-mapper"));
const uniqueId_1 = __importDefault(require("lodash/uniqueId"));
const createThrottle_1 = __importDefault(require("../../../Hooks/createThrottle"));
const Utils_1 = require("../../../Utils");
const WithResponsiveColumns_1 = require("../../UI/ResponsiveColumns/WithResponsiveColumns");
var ImageMapType;
(function (ImageMapType) {
    ImageMapType["POLYGON"] = "polygon";
    ImageMapType["RECTANGLE"] = "rectangle";
    ImageMapType["CIRCLE"] = "circle";
})(ImageMapType = exports.ImageMapType || (exports.ImageMapType = {}));
const RESIZE_THROTTLE = 200;
const ClickableImageBlock = ({ image, imageAreas }) => {
    const imageMapperRef = (0, react_1.useRef)(null);
    const containerRef = (0, react_1.useRef)(null);
    const [mapperId] = (0, react_1.useState)((0, uniqueId_1.default)('input-'));
    const [map, setMap] = (0, react_1.useState)([]);
    const [initialImageSizes, setInitialImageSizes] = (0, react_1.useState)({
        width: 0,
        height: 0,
        heightRatio: 0
    });
    const [imageSizes, setImageSizes] = (0, react_1.useState)({ width: 0, height: 0 });
    const setImageSizesHandler = (imageWidth, containerWidth) => {
        if (imageWidth > containerWidth) {
            setImageSizes({
                width: containerWidth,
                height: containerWidth / initialImageSizes.heightRatio
            });
            const ratio = containerWidth / imageWidth;
            setMap((0, Utils_1.generateImageMap)(imageAreas, ratio));
        }
        else {
            setImageSizes({ width: imageWidth, height: initialImageSizes.height });
            setMap((0, Utils_1.generateImageMap)(imageAreas));
        }
    };
    (0, react_1.useEffect)(() => {
        const imageMap = new Image();
        imageMap.src = image;
        imageMap.onload = () => {
            const imageMapWidth = imageMap.width;
            const imageMapHeight = imageMap.height;
            const heightRatio = imageMapWidth / imageMapHeight;
            setInitialImageSizes({ width: imageMapWidth, height: imageMapHeight, heightRatio: heightRatio });
            setImageSizesHandler(imageMapWidth, containerRef.current.clientWidth);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const resizeFn = (0, createThrottle_1.default)(() => {
            setImageSizesHandler(initialImageSizes.width, containerRef.current.clientWidth);
        }, RESIZE_THROTTLE);
        resizeFn();
        window.addEventListener('resize', resizeFn);
        return () => window.removeEventListener('resize', resizeFn);
    }, [initialImageSizes]);
    const onLoad = () => {
        var _a;
        for (let i = 0; i < imageMapperRef.current.children.length; i++) {
            const element = imageMapperRef.current.children[i];
            if (element.tagName === 'MAP') {
                let key = 0;
                for (const child of element.children) {
                    const typedChild = child;
                    if ((_a = imageAreas === null || imageAreas === void 0 ? void 0 : imageAreas[key]) === null || _a === void 0 ? void 0 : _a.title) {
                        typedChild.title = imageAreas[key].title;
                    }
                    key++;
                }
            }
        }
    };
    return (react_1.default.createElement(styled.Container, { ref: containerRef }, image && (react_1.default.createElement(react_img_mapper_1.default, { src: image, width: imageSizes.width, height: imageSizes.height, map: { name: mapperId, areas: map }, containerRef: imageMapperRef, onLoad: onLoad }))));
};
exports.ClickableImageBlock = ClickableImageBlock;
exports.default = (0, WithResponsiveColumns_1.WithResponsiveColumns)(exports.ClickableImageBlock);
